import { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';

import logoSulamerica from '../../../../assets/assessoria/logoSulamericaWhite.svg';
import configsIcon from '../../../../assets/segmentacao/regulamento.svg';
import chevronDown from '../../../../assets/svgs/chevron_down-icon.svg';
import chevronUp from '../../../../assets/svgs/chevron_up-icon.svg';
import hamburgerIcon from '../../../../assets/svgs/hamburgerIcon.svg';
import homeIcon from '../../../../assets/svgs/homeIcon.svg';
import logoutIcon from '../../../../assets/svgs/logoutIcon.svg';
import { CustomIcon } from '../../../../components/widgets/CustomIcon';
import { useAuthContext } from '../../../../contexts/AuthContext';
import closeIcon from '../assets/icons/close-icon.svg';
import info from '../assets/icons/info_24px.svg';
import praSaberSidebar from '../assets/icons/pra_saber_sidebar.svg';
import logo from '../assets/logo/PRA_360_LOGO.svg';
import { getDataSegmentationSensedia } from '../services/segmentacao';
import { classificacao } from '../utils/classificacao';

type itemsType = {
  title: string;
  icon: JSX.Element;
  action: () => void;
  options: {
    name: string;
    link: string;
  }[];
};

type HeaderGlobalMobileProps = {
  items?: itemsType[];
};

export const SegmentacaoHeaderMobile = () => {
  const pathname = location.pathname;
  const navigate = useNavigate();
  const { logout } = useAuthContext();

  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);
  const [segmentacao, setSegmentacao] = useState<string>('');
  const [medalha, setMedalha] = useState<any>();

  const getData = async () => {
    try {
      const { data } = await getDataSegmentationSensedia();

      const year = new Date().getFullYear().toString();
      const month = new Date().getMonth().toString();

      const segmentacao = data.find(
        (item) => item.cod_ano_mes_segmentacao === `${year}${month}`
      );

      if (data) {
        setSegmentacao(segmentacao.dsc_faixa_segmentacao);
        const isSegmentation = classificacao.find(
          (item) => item.number === Number(data[0].cod_faixa_segmentacao)
        );

        setMedalha(isSegmentation);
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  const { user } = JSON.parse(localStorage.getItem('pdn:user') as string) || {
    user: { name: 'Joaquim Bira' }
  };

  const items = [
    {
      title: 'Início',
      description: 'Painel de Segmentação de Corretores',
      url: '/corretor/pra360',
      icon: <img src={homeIcon} />,
      options: []
    },
    {
      title: 'Regulamento',
      isBeta: false,
      url: '/corretor/pra360/regulamentacao',
      icon: <img src={configsIcon} />,
      options: []
    },
    {
      title: 'Ajuda',
      url: '/corretor/pra360/ajuda',
      icon: <img src={info} />,
      options: []
    },
    {
      title: '',
      isBeta: false,
      url: '/corretor/pra360/prasaber',
      icon: <img src={praSaberSidebar} />,
      options: []
    },
    {
      title: 'Sair',
      url: '/corretor',
      icon: <img src={logoutIcon} />,
      options: []
    }
  ];

  const userName = user.name.split(' ');

  const userAvatar =
    user.name.split(' ').length > 1
      ? user.name.split(' ')[0].charAt(0).toUpperCase() +
        user?.name.split(' ')[1].charAt(0).toUpperCase()
      : user.name.split(' ')[0].charAt(0).toUpperCase() +
          user?.name.split(' ')[0].charAt(0).toUpperCase() || '';

  const itemsDefault = items
    ? items
    : [
        {
          title: 'Sair',
          icon: <CustomIcon src={logoutIcon} />,
          action: () => logout(),
          options: []
        }
      ];

  const disableScroll = () => {
    if (menuIsOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };

  useEffect(() => {
    getData();
    disableScroll();
  }, [menuIsOpen]);

  return (
    <>
      <div className="tw-h-[64px] tw-bg-[#001E64] tw-flex tw-justify-between tw-px-[16px] tw-py-[20px] md:tw-hidden">
        <img src={logoSulamerica} alt="logo" />
        <button onClick={() => setMenuIsOpen(!menuIsOpen)}>
          <CustomIcon src={hamburgerIcon} />
        </button>
      </div>
      {menuIsOpen && (
        <div className="tw-absolute tw-bg-[#FFFFFF] tw-max-w-full tw-h-full tw-z-50 tw-w-full">
          <div className="tw-p-5 tw-flex tw-bg-[#001E64] tw-justify-between tw-gap-[5px]">
            <div className="tw-flext tw-flex-col tw-w-full">
              <div className="tw-flex tw-flex-row tw-justify-between tw-gap-[10px]">
                <div className="tw-flex tw-flex-row tw-gap-[10px]">
                  <div className="tw-rounded-full tw-w-9 tw-p-2 tw-h-9 tw-bg-[#FF8C00] tw-flex tw-items-center tw-justify-center tw-text-[#FFFFFF] tw-text-[0.75rem] tw-font-semibold">
                    {userAvatar}
                  </div>
                  <div className="tw-flex tw-flex-col">
                    {userName.map((name, index) => (
                      <div key={index} className="">
                        {index === 0 ? (
                          <p className="tw-text-[1.25rem] tw-text-[#FFFFFF] tw-flex">
                            Olá, &nbsp; <strong>{name}</strong>
                          </p>
                        ) : index <= 2 ? (
                          <p className="tw-text-[1.25rem] tw-text-[#FFFFFF] tw-font-bold tw-flex">
                            {name}
                          </p>
                        ) : null}
                      </div>
                    ))}
                  </div>
                </div>

                <button
                  className="tw-font-bold tw-text-[#FFFFFF] tw-text-[18px] tw-h-[18px] tw-w-[18px] tw-text-center"
                  onClick={() => setMenuIsOpen(false)}
                >
                  <CustomIcon
                    src={closeIcon}
                    width={15}
                    height={15}
                    color="white"
                  />
                </button>
              </div>

              <div className="tw-flex tw-mt-1">
                <p className="tw-bg-[#2A4E9A] tw-text-[#FFFFFF] tw-text-[0.75rem] tw-p-2 tw-h-[1.5rem] tw-rounded-[0.46875rem] tw-flex tw-justify-start tw-items-center">
                  Categoria {segmentacao ? segmentacao : 'não definida'}
                  {segmentacao && (
                    <img
                      className="tw-ml-2 tw-h-4 tw-w-4"
                      src={medalha ? medalha.imageSrc : ''}
                    />
                  )}
                </p>
              </div>
            </div>
          </div>
          <hr />
          <div className="tw-flex tw-flex-col">
            <div className="tw-flex tw-px-10">
              <img className="" src={logo} alt="teste" />
            </div>
            {itemsDefault?.map((item, index) => {
              return (
                <div key={index} className="tw-flex tw-flex-col">
                  <a href={process.env.REACT_APP_PORTAL_URL}>
                    <Link
                      className={`tw-w-full tw-flex tw-gap-4 tw-py-3 tw-px-4 tw-text-[#001E64] tw-cursor-pointer tw-full tw-justify-between ${
                        pathname === item.url &&
                        'tw-text-[#146CFA] tw-bg-[#E6F7FF] tw-font-bold'
                      }`}
                      to={item.url || '#'}
                      onClick={() => setMenuIsOpen(!menuIsOpen)}
                    >
                      <div className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-justify-between">
                        <span>{item.icon}</span>
                        <p>{item.title}</p>
                        {pathname === item.url ? (
                          <div className="tw-border-r-4 tw-border-blue-500 tw-rounded-l-md" />
                        ) : null}
                      </div>
                      {item.options.length >= 1 && (
                        <CustomIcon
                          src={!dropdownIsOpen ? chevronUp : chevronDown}
                        />
                      )}
                    </Link>
                  </a>
                </div>
              );
            })}

            <div className="tw-flex tw-p-4">
              <div className="tw-gap-4 tw-p-4 tw-rounded-md tw-bg-[#F4F4F4]">
                <a>
                  Em caso de{' '}
                  <strong>
                    dúvidas entre em contato com seu gestor comercial.
                  </strong>
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
